import template from './urban-total-area.jade';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.urbanTotalArea', [])
    .directive('isZeroTotalArea', () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, element, attrs, ngModel) => {
                ngModel.$validators.zerovalue = value => {
                    return value > 0
                };
            }
        };
    })
    .directive('cianAfAboutObjectUrbanTotalArea', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller: ['deviceService', function (deviceService) {
            this.isMobile = deviceService.isMobile;
            this.areaMax = 10000000;
            this.getKitchenAndLivingArea = () => {
                return (Number(this.ad.livingArea) || 0) + (Number(this.ad.kitchenArea) || 0); // значение может быть не задано, поэтому через 'или'
            };
            this.validation = validation(this.form, 'urbanTotalArea', {
                parse: 'Введите число',
                required: 'Укажите общую площадь',
                zerovalue: 'Введите корректное значение',
                min: 'Общая площадь объекта не должна быть меньше суммы площадей кухни и жилой площади',
                max: 'Допустимо не более 7 символов',
            });
        }],
        controllerAs: 'urbanTotalArea',
        template,
    }))
    .name;
